import Index from '../../pages/travel/invitation/index';
import Help from '../../pages/travel/invitation/help';
import Pc from '../../pages/travel/invitation/pc';

const base = 'invitation';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Help
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/travel/invitation.js